import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as types from './types';
export default _defineProperty({}, types.SET_NOTIFICATION_BANNER, function (state, payload) {
  state.notification = payload;
});